import { css } from "styled-components";

/**
 * North/Text/Subtitle — Satoshi Regular 16px.
 * Use for body copy, helpers, labels, and form control text on the profile form.
 */
export const subtitleTextStyles = css`
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0;
`;

/** Field question labels (same family/size, bold for hierarchy). */
export const fieldLabelStyles = css`
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0;
`;

/** Small caption / char-count text. */
export const captionTextStyles = css`
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-weight: 500;
  font-size: 12px;
  line-height: 1;
  letter-spacing: 0;
`;

/**
 * Multi-line inputs. north.js wraps its textarea in a GrowWrap div whose
 * `> textarea` rule outranks the styled(TextArea) class, so these override
 * its `font: inherit` and 8px padding and need !important to win.
 */
export const textAreaStyles = css`
  font-family: ${({ theme }) =>
    theme.globalConstants.fontFamily.body} !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 150% !important;
  letter-spacing: 0 !important;
  padding: 10px 16px !important;

  &::placeholder {
    color: ${({ theme }) =>
      theme.globalConstants.color.textTertiary} !important;
  }
`;

/** Action button label — Satoshi Bold 16px. */
export const actionButtonTextStyles = css`
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
`;
